// @flow
import * as React from "react";
import OrderServerRequest from "./order_server_request";
import DiscountServerRequest from "./discount_server_request";
import OrderForm from "./components/order_form";
import InvoiceFormContainer from "./containers/invoice_form_container";
declare var StripeCheckout;

type StripeHandler = {
  open: (payload: {}) => mixed
};

type Props = {
  disableWith: string,
  enableWith: string,
  quantity: number,
  baseprice: number,
  stripekey: string,
  schoolName: string
};

type State = {
  amount: number,
  quantity: number,
  buttonText: string,
  disabled: boolean,
  showInvoiceButton: boolean,
  enableInvoice: boolean
};

class OrderFormContainer extends React.Component<Props, State> {
  static defaultProps = {
    disableWith: "Paying ...",
    enableWith: "Pay with card",
    quantity: 1,
    enableInvoice: false,
    showInvoiceButton: false
  };

  state = {
    amount: this.props.baseprice,
    quantity: this.props.quantity,
    buttonText: this.props.enableWith,
    disabled: false,
    showInvoiceButton: false,
    enableInvoice: false
  };

  stripeHandler: StripeHandler;

  componentDidMount() {
    this.stripeHandler = StripeCheckout.configure({
      key: this.props.stripekey,
      image: "https://stripe.com/img/documentation/checkout/marketplace.png",
      token: OrderServerRequest.bind(this)
    });
  }

  disable = () => {
    this.setState({
      disabled: true,
      buttonText: this.props.disableWith
    });
  };

  enable = () => {
    this.setState({
      disabled: false,
      buttonText: this.props.enableWith
    });
  };

  updateAmount = (quantity: number, discountApplied: number = 0) => {
    const showInvoiceButton = this.enableInvoice(quantity);
    const disableInvoice = !showInvoiceButton;
    const amount = this.props.baseprice * quantity - discountApplied;
    const newState = {
      quantity: quantity,
      amount: amount,
      showInvoiceButton: showInvoiceButton
    };
    const state = disableInvoice
      ? { ...newState, enableInvoice: false }
      : newState;

    this.setState(state);
  };

  handleUpdateAmount = (e: SyntheticEvent<HTMLInputElement>) => {
    const quantity = parseInt(e.currentTarget.value, 10);
    const applyDiscount = this.applyDiscount(quantity);

    if (applyDiscount) {
      this.updateAmountWithDiscount(quantity);
    } else {
      this.updateAmount(quantity);
    }
  };

  applyDiscount = (quantity: number) => quantity >= 100;

  updateAmountWithDiscount = (quantity: number) => {
    const discountRequest = DiscountServerRequest(quantity);

    discountRequest.then(discount => {
      this.updateAmount(quantity, discount);
    });
  };

  handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.setState({ enableInvoice: false });

    this.stripeHandler.open({
      amount: this.state.amount
    });
  };

  handleInvoice = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    this.setState({
      enableInvoice: this.enableInvoice(this.state.quantity)
    });
  };

  // TODO: Remove the false part of this function in order to properly display the invoice button.
  // This function will never return true so invoice button will never be displayed.
  enableInvoice = (quantity: number) => quantity >= 20;

  invoiceFormContainer = () =>
    this.state.enableInvoice ? (
      <InvoiceFormContainer
        quantity={this.state.quantity}
        buttonText="Submit"
        schoolName={this.props.schoolName}
        disableFields={false}
      />
    ) : null;

  render() {
    return (
      <div>
        <OrderForm
          quantity={this.state.quantity}
          buttonText={this.state.buttonText}
          disabled={this.state.disabled}
          updateAmount={this.handleUpdateAmount}
          handleSubmit={this.handleSubmit}
          showInvoiceButton={this.state.showInvoiceButton}
          handleInvoice={this.handleInvoice.bind(this)}
        />
        {this.invoiceFormContainer()}
      </div>
    );
  }
}

export default OrderFormContainer;



// WEBPACK FOOTER //
// ./app/javascript/order_form/index.jsx